import { Screenmode } from './screenmode'
import 'js-cookie'

export default class {
  constructor (settings = {}) {
    this.options = $.extend({
      selectors: {
        pageHeader: '.page-header',
        pageHeaderToggleMobileNavigation: '.page-header__toggle-mobile-navigation',
        mainNavigation: '.main-navigation',
        mainNavigationLevel1Links: '.main-navigation__level-1 > li > a',
        mainNavigationLevel2Links: '.main-navigation__level-2 > li > a',
        mainNavigationLevelallLinks: '.main-navigation__level-1 li > a',
        mainNavigationLevel2Container: '.main-navigation__level-2-container',
        mainNavigationLevel3Container: '.main-navigation__level-3-container',
        mainNavigationLevel2ContainerOpened: '.main-navigation--open > .main-navigation__level-2-container',
        mainNavigationBack: '.main-navigation__back',
        mainNavigationClose: '.main-navigation__close',
        isFocus: '.is--focus',
        contactOverlay: '.contact-overlay',
        banner: '.page-header__banner',
        bannerClose: '.page-header__banner-close'
      },
      classes: {
        pageHeaderCompact: 'page-header--compact',
        bodyOnScrolling: 'is--header-scrolling',
        bodyNoScroll: 'is--no-scroll',
        bodyMobileNavigationOpen: 'is--open-mobile-navigation',
        pageHeaderMainNavigationOpen: 'page-header--main-navigation-open',
        mainNavigationOpen: 'main-navigation--open',
        isFocus: 'is--focus',
        mainNavigationShowLevel2: 'main-navigation--show-level-2',
        mainNavigationShowLevel3: 'main-navigation--show-level-3',
        mainNavigationShowLevel4: 'main-navigation--show-level-4',
        contactOverlayOpen: 'contact-overlay--open',
        active: 'is--active'
      },
      scrollingHeaderTop: {
        xs: 70,
        sm: 70,
        md: 115,
        lg: 150,
        xl: 150
      }
    },
    settings)

    this.$Cookies = require('js-cookie')
    this.$banner = $(this.options.selectors.banner)
    this.$bannerClose = $(this.options.selectors.bannerClose)
  }

  init () {
    const that = this
    let resizeTimer
    const pageHeader = $(that.options.selectors.pageHeader)

    $(window)
      .resize(function () {
        clearTimeout(resizeTimer)

        resizeTimer = setTimeout(function () {
          let level2ContainerTop

          const currentBreakpoint = new Screenmode().getCurrentBreakpoint()

          const openLevel2Container = $(that.options.selectors.mainNavigationLevel2ContainerOpened)

          const level1Link = $(that.options.selectors.mainNavigationLevel1Links).eq(0)

          if (openLevel2Container.length > 0) {
            if ($(document).scrollTop() >= that.getHeaderHeight(currentBreakpoint)) {
              level2ContainerTop = $(that.options.selectors.pageHeader).height()
            } else {
              level2ContainerTop = ((level1Link.offset().top + level1Link.height()) - $(document).scrollTop())
            }

            if (currentBreakpoint !== 'xs' && currentBreakpoint !== 'sm') {
              openLevel2Container
                .css('top', level2ContainerTop + 'px')
                .css('height', 'calc(100vh - ' + level2ContainerTop + 'px)')
            }
          }

          if (currentBreakpoint !== 'xs' && currentBreakpoint !== 'sm' && $('body').hasClass(that.options.classes.bodyMobileNavigationOpen)) {
            that.closeMobileNavigation()
          }
        }, 250)
      })

    // Change header on scrolling
    if (!pageHeader.hasClass(that.options.classes.pageHeaderCompact)) {
      $(document)
        .scroll(function () {
          that.checkHeaderScrolling()
        })

      that.checkHeaderScrolling()
    }

    that.addEvents()

    that.addMainNavigationEvents()

    that.addMobileNavigationEvents()

    if (!that.getCookie('bannerclose')) {
      this.$banner.addClass(that.options.classes.active)
      this.$bannerClose.attr('aria-expanded', 'true')
    }
  }

  checkHeaderScrolling () {
    const that = this
    const screenMode = new Screenmode()

    if ($(document).scrollTop() >= that.getHeaderHeight(screenMode.getCurrentBreakpoint())) {
      $('body')
        .addClass(that.options.classes.bodyOnScrolling)
    } else {
      $('body')
        .removeClass(that.options.classes.bodyOnScrolling)
    }
  }

  addEvents () {
    const that = this

    this.$bannerClose.on({
      click: () => {
        this.$banner.removeClass(that.options.classes.active)
        this.$bannerClose.attr('aria-expanded', 'false')
        that.setCookie('bannerclose', '1')
      }
    })
  }

  addMainNavigationEvents () {
    const that = this

    // Add activation class for main navigation links level 1
    $(that.options.selectors.mainNavigationLevel1Links)
      .unbind('focus')
      .on({
        focus: function () {
          const element = $(this)
          const thisParentLi = element.parent('li')
          const thisLevel2Container = thisParentLi.children(that.options.selectors.mainNavigationLevel2Container)

          if (thisLevel2Container.length === 1) {
            if (!thisParentLi.hasClass(that.options.classes.mainNavigationOpen)) {
              element
                .trigger('mousedown')
            }
          } else {
            that.closeMainNavigation()
          }

          element
            .addClass(that.options.classes.isFocus)
        },
        click: function (event) {
          const element = $(this)
          const thisParentLi = element.parent('li')
          const thisLevel2Container = thisParentLi.children(that.options.selectors.mainNavigationLevel2Container)

          if (thisLevel2Container.length === 1) {
            event.preventDefault()
          }

          $(this).blur()
        },
        mousedown: function (event) {
          const element = $(this)
          const allParentLi = $(that.options.selectors.mainNavigationLevelallLinks).parent('li')
          const thisParentLi = element.parent('li')
          const body = $('body')
          const pageHeader = $(that.options.selectors.pageHeader)
          const thisLevel2Container = thisParentLi.children(that.options.selectors.mainNavigationLevel2Container)
          const currentBreakpoint = new Screenmode().getCurrentBreakpoint()
          let level2ContainerTop
          const contactOverlay = $(that.options.selectors.contactOverlay)

          event.stopPropagation()
          event.preventDefault()

          // Have level 2?
          if (thisLevel2Container.length === 1) {
            // Is opened? => deactivate
            if (thisParentLi.hasClass(that.options.classes.mainNavigationOpen)) {
              allParentLi
                .removeClass(that.options.classes.mainNavigationOpen)

              that.removeFocus()

              body
                .removeClass(that.options.classes.bodyNoScroll)

              pageHeader
                .removeClass(that.options.classes.pageHeaderMainNavigationOpen)

              thisLevel2Container
                .css('top', '0')
                .css('height', 'inherit')
            } else {
              that.removeFocus()

              allParentLi
                .removeClass(that.options.classes.mainNavigationOpen)

              thisParentLi
                .addClass(that.options.classes.mainNavigationOpen)

              pageHeader
                .addClass(that.options.classes.pageHeaderMainNavigationOpen)

              body
                .addClass(that.options.classes.bodyNoScroll)

              contactOverlay
                .removeClass(that.options.classes.contactOverlayOpen)

              if ($(document).scrollTop() >= that.getHeaderHeight(currentBreakpoint)) {
                level2ContainerTop = $(that.options.selectors.pageHeader).height()
              } else {
                level2ContainerTop = ((element.offset().top + element.height()) - $(document).scrollTop())
              }

              if (currentBreakpoint !== 'xs' && currentBreakpoint !== 'sm') {
                thisLevel2Container
                  .css('top', level2ContainerTop + 'px')
                  .css('height', 'calc(100vh - ' + level2ContainerTop + 'px)')
              }

              that.setMainNavigationLevel(2)
            }
          } else {
            that.closeMainNavigation()
          }
        }
      })

    // Add activation class for main navigation links level 2
    $(that.options.selectors.mainNavigationLevel2Links)
      .unbind('click focus mousedown')
      .on({
        focus: function () {
          const element = $(this)
          const thisParentLi = element.parent('li')
          const allParentLi = $(that.options.selectors.mainNavigationLevel2Links).parent('li')

          if (thisParentLi.children(that.options.selectors.mainNavigationLevel3Container).length === 1) {
            element
              .trigger('mousedown')
          } else {
            allParentLi
              .removeClass(that.options.classes.mainNavigationOpen)

            that.setMainNavigationLevel(2)
          }

          element
            .addClass(that.options.classes.isFocus)
        },
        click: function (event) {
          const element = $(this)
          const thisParentLi = element.parent('li')

          if (thisParentLi.children(that.options.selectors.mainNavigationLevel3Container).length === 1) {
            event.preventDefault()
          }

          element.blur()
        },
        mousedown: function (event) {
          const allParentLi = $(that.options.selectors.mainNavigationLevel2Links).parent('li')
          const thisParentLi = $(this).parent('li')

          event.stopPropagation()
          event.preventDefault()

          if (thisParentLi.children(that.options.selectors.mainNavigationLevel3Container).length === 1) {
            that.removeFocus()

            $(that.options.selectors.mainNavigationLevel3Container)
              .find('li')
              .removeClass(that.options.classes.mainNavigationOpen)

            if (!thisParentLi.hasClass(that.options.classes.mainNavigationOpen)) {
              allParentLi
                .removeClass(that.options.classes.mainNavigationOpen)

              thisParentLi
                .addClass(that.options.classes.mainNavigationOpen)

              that.setMainNavigationLevel(3)
            }
          }
        }
      })

    // Hide main navigation flyout on close button click
    $(that.options.selectors.mainNavigationClose)
      .on({
        click: function (event) {
          that.closeMainNavigation()
        }
      })

    $(document)
      .on({
        keyup: function (event) {
          // Tab
          if (event.originalEvent.keyCode === 9) {
            const focusedElement = $(this).find(':focus')

            if (focusedElement.closest(that.options.selectors.mainNavigation).length === 0) {
              that.closeMainNavigation()
            }
          }
        }
      })
  }

  closeMainNavigation () {
    const that = this

    // Remove all open classes from main navigation
    $(that.options.selectors.mainNavigationLevelallLinks)
      .parent('li')
      .removeClass(that.options.classes.mainNavigationOpen)

    // Remove styles for page header
    $(that.options.selectors.pageHeader)
      .removeClass(that.options.classes.pageHeaderMainNavigationOpen)

    $(that.options.selectors.mainNavigationLevel2Container)
      .css('top', '0')
      .css('height', 'inherit')

    that.setMainNavigationLevel()

    // Remove no scroll script for main content
    $('body')
      .removeClass(that.options.classes.bodyNoScroll)
  }

  addMobileNavigationEvents () {
    const that = this

    $(that.options.selectors.pageHeaderToggleMobileNavigation)
      .on({
        click: function (event) {
          const body = $('body')
          const contactOverlay = $(that.options.selectors.contactOverlay)

          event.preventDefault()

          contactOverlay
            .removeClass(that.options.classes.contactOverlayOpen)

          if (body.hasClass(that.options.classes.bodyMobileNavigationOpen)) {
            that.closeMobileNavigation()
          } else {
            that.openMobileNavigation()
          }
        }
      })

    $(that.options.selectors.mainNavigationBack)
      .on({
        click: function (event) {
          that.goBackMainNavigationLevel()
        }
      })
  }

  openMobileNavigation () {
    const that = this
    const body = $('body')

    body
      .addClass(that.options.classes.bodyMobileNavigationOpen)
      .addClass(that.options.classes.bodyNoScroll)
  }

  closeMobileNavigation () {
    const that = this
    const body = $('body')

    body
      .removeClass(that.options.classes.bodyMobileNavigationOpen)
      .removeClass(that.options.classes.bodyNoScroll)
  }

  setMainNavigationLevel (level = null) {
    const that = this
    const mainNavigation = $(that.options.selectors.mainNavigation)

    if (level === 2) {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel3)
        .removeClass(that.options.classes.mainNavigationShowLevel4)
        .addClass(that.options.classes.mainNavigationShowLevel2)
    } else if (level === 3) {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel2)
        .removeClass(that.options.classes.mainNavigationShowLevel4)
        .addClass(that.options.classes.mainNavigationShowLevel3)
    } else if (level === 4) {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel2)
        .removeClass(that.options.classes.mainNavigationShowLevel3)
        .addClass(that.options.classes.mainNavigationShowLevel4)
    } else {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel2)
        .removeClass(that.options.classes.mainNavigationShowLevel3)
        .removeClass(that.options.classes.mainNavigationShowLevel4)
    }
  }

  goBackMainNavigationLevel () {
    const that = this
    const mainNavigation = $(that.options.selectors.mainNavigation)

    if (mainNavigation.hasClass(that.options.classes.mainNavigationShowLevel3)) {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel3)
        .removeClass(that.options.classes.mainNavigationShowLevel4)
        .addClass(that.options.classes.mainNavigationShowLevel2)

      $(that.options.selectors.mainNavigationLevel2Container)
        .find('li')
        .removeClass(that.options.classes.mainNavigationOpen)
    } else if (mainNavigation.hasClass(that.options.classes.mainNavigationShowLevel4)) {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel2)
        .removeClass(that.options.classes.mainNavigationShowLevel4)
        .addClass(that.options.classes.mainNavigationShowLevel3)

      $(that.options.selectors.mainNavigationLevel3Container)
        .find('li')
        .removeClass(that.options.classes.mainNavigationOpen)
    } else {
      mainNavigation
        .removeClass(that.options.classes.mainNavigationShowLevel2)
        .removeClass(that.options.classes.mainNavigationShowLevel3)
        .removeClass(that.options.classes.mainNavigationShowLevel4)

      $(that.options.selectors.mainNavigation)
        .find('li')
        .removeClass(that.options.classes.mainNavigationOpen)
    }
  }

  resetNavigation () {
    const that = this
    const mainNavigation = $(that.options.selectors.mainNavigation)

    that.closeMainNavigation()
    that.closeMobileNavigation()

    mainNavigation
      .removeClass(that.options.classes.mainNavigationShowLevel2)
      .removeClass(that.options.classes.mainNavigationShowLevel3)
      .removeClass(that.options.classes.mainNavigationShowLevel4)

    $(that.options.selectors.mainNavigation)
      .find('li')
      .removeClass(that.options.classes.mainNavigationOpen)
  }

  removeFocus () {
    $(this.options.selectors.isFocus)
      .removeClass(this.options.classes.isFocus)
  }

  getHeaderHeight (viewport) {
    return window.getComputedStyle(document.querySelector('body')).getPropertyValue('--scrolling-header-height-' + viewport).replace('px', '')
  }

  setCookie (name = '', value = '0') {
    this.$Cookies.set(name, value, {
      path: '/'
    })
  }

  getCookie (name) {
    return this.$Cookies.get(name)
  }
}
